import React, { useContext, useEffect } from "react";
import styles from "./DeleteProfilePopup.module.css";
import { useLocation, useNavigate } from "react-router";
import signOut from "../../assests/popup/signOut.svg";

const DeleteProfilePopup = () => {
  const navigate = useNavigate();
  const location = useLocation();
  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "unset";
    };
  }, []);
  return (
    <div className="fixed top-0 left-0 w-[100%] h-[100%] flex items-center justify-center p-[20px] z-100 text-center z-10 popupBackground">
      <div className={styles.deteleme}>
        <img src={signOut} alt="" className="w-[56px] h-[56px] mb-[24px]" />
        <p className="text-regular-medium px-[20px] mb-[16px]">
          Request Submitted
        </p>
        <p className="text-small text-[#CDCDCD] px-[20px]">
          Your request has been successfully submitted. It may take 24 to 48
          hours to delete your account.
        </p>
        <div className="seperator my-[20px]" />
        <div className="flex flex-col gap-[16px] w-[100%] cursor-pointer">
          <button
            className={styles.signOutButton}
            onClick={() => {
              navigate("/");
              window.location.reload();
            }}
          >
            <p className="text-regular-medium">OK</p>
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteProfilePopup;
